<template>
  <div class="pd-30 comment-page">
    <div class="list">
      <div v-if="!commentList.length" class="text-center">暂无数据</div>
      <Cell v-for="c in currentList" :key="c.id" :data="c" />
    </div>
    <div ref="loadmore" class="text-center pt-30 pb-30 load-more">
      {{ isComplete ? "到底了" : "加载更多..." }}
    </div>
  </div>
</template>

<script>
import Cell from "./item";
const PAGE_SIZE = 20;
export default {
  components: { Cell },
  data() {
    return {
      info: {},
      page: 1,
    };
  },
  computed: {
    commentList() {
      return (this.info.orderEvaluates || []).filter((o) => !!o.userName);
    },
    totalPage() {
      return Math.ceil(this.commentList.length / PAGE_SIZE);
    },
    isComplete() {
      return this.page >= this.totalPage;
    },
    currentList() {
      return this.commentList.slice(0, this.page * PAGE_SIZE);
    },
    testList() {
      return [
        ...this.commentList,
        ...Array.from({ length: 500 }, () => {
          return {
            content: "sadasd",
            userName: "dasd",
            wxProfilePhoto:
              "http://thirdwx.qlogo.cn/mmopen/vi_32/fC570Fn55ibnAibgJSeusibkEHOfT4rWVYy2tXnUvkpBBwlGsICjcqlXRjkKazhickwNiaIraL6shjaOXicmryR9ctlw/132",
          };
        }),
      ];
    },
  },

  mounted() {
    this.getInfo();
    const inb = new IntersectionObserver(
      ([en]) => {
        if (en.intersectionRatio === 1 && en.isIntersecting) {
          this.next();
        }
      },
      {
        threshold: [1],
      }
    );
    inb.observe(this.$refs.loadmore);
  },

  methods: {
    next() {
      if (this.isComplete) {
        return;
      }
      this.page++;
    },
    async getInfo() {
      this.info = await this.$http.post("/wx/WeiXinProductDetail", {
        jid: localStorage.getItem("jid"),
        productId: this.$route.params.id,
        memberId: this.$store.state.user.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-page {
  overflow: auto;
  .load-more {
    color: #888;
  }
  .list {
    min-height: 100vh;
  }
}
</style>
